import api from "./api";

const ItemService = {
  // getAllItems: async () => {
  //   const res = await api.get("/items/getAll");
  //   return res.data;
  // },

  getAllItems: async (page = 1, limit = 20, search = "", categoryId = "") => {
    const res = await api.get(`/items/getAll?page=${page}&limit=${limit}&search=${search}&categoryId=${categoryId}`);
    return res.data;
  },


  saveItem: async (data) => {
    const res = await api.post("/items/save", data);
    return res.data;
  },

  getItemById: async (id) => {
    const res = await api.get(`/items/getById/${id}`);
    return res.data;
  },

  getItemByCategoryId: async (categoryId) => {
    const res = await api.get(`/items/getByCategoryId/${categoryId}`);
    return res.data;
  },

  updateItem: async (id, data) => {
    const res = await api.put(`/items/update/${id}`, data);
    return res.data;
  },

  getActive: async () => {
    const response = await api.get("/items/getActive/list");
    return response.data;
  },

  deleteItem: async (id) => {
    const res = await api.delete(`/items/${id}`);
    return res.data;
  },

  updateStatus: async (id, status) => {
    const res = await api.put(`/items/updateStatus/${id}`, { status });
    return res.data;
  },
};

export default ItemService;
